<template>
    <modal :show="true" :show-close="true" @close="$emit('close')">
        <template slot="header">
            <h5 class="modal-title">Conference Details</h5>
        </template>
        <template>
            <p v-if="conference">
                This conference happened on {{ moment(conference.datetime).format('LLL') }} and lasted for
                {{ moment.duration(conference.duration, 'seconds').format("h [hrs], m [min]") }}
            </p>
            <el-table v-loading="loading.students" :row-class-name="tableRowClassName" :data="students"
                      max-height="400">
                <el-table-column
                    min-width="70"
                    label="Number"
                    property="number"
                ></el-table-column>
                <el-table-column
                    min-width="130"
                    label="Name"
                    property="name"
                ></el-table-column>
                <el-table-column
                    min-width="80"
                    label="Attendance"
                >
                    <div slot-scope="{ row }">
                        {{ calculateStudentAttendance(row.pin) }} %
                    </div>
                </el-table-column>
            </el-table>
        </template>


        <template slot="footer">
            <base-button type="secondary" @click.native="$emit('close')">Close</base-button>
        </template>
    </modal>
</template>
<script>
import Modal from "../../components/Modal";
import axios from "axios";

export default {
    name: 'ConferenceDetailModal',
    components: {
        Modal,
    },
    props: ['conference_id', 'classroom_id'],
    data() {
        return {
            conference: null,
            students: null,
            loading: {
                conference: true,
                students: true,
            },
        }
    },
    mounted() {
        this.loadConference();
        this.loadStudents();
    },
    methods: {
        loadStudents() {
            this.loading.students = true;
            axios({
                url: this.baseAPIURL + 'classroom/' + this.classroom_id + '/student', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                this.students = resp.data.data;
            }).finally(() => {
                this.loading.students = false;
            });
        },
        loadConference() {
            this.loading.conference = true;
            return axios({
                url: this.baseAPIURL + 'classroom/' + this.classroom_id + '/conference/cdr/' + this.conference_id,
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            }).then(resp => {
                this.conference = resp.data.data;
            }).finally(() => {
                this.loading.conference = false;
            });
        },
        calculateStudentAttendance(student_pin) {
            if (this.conference.attendees[student_pin] === undefined) {
                return 0;
            }

            return (this.conference.attendees[student_pin].percentage * 100).toFixed(0);

        },
        tableRowClassName({row, rowIndex}) {
            let pin = row.pin;

            let attended = this.conference.attendees[pin];

            if (attended === undefined) {
                return 'table-danger';
            }

            if (attended.percentage < 0.9) {
                return 'table-warning';
            }
            //
            // if (rowIndex === 0) {
            //     return 'table-success';
            // } else if (rowIndex === 2) {
            //     return 'table-info';
            // } else if (rowIndex === 4) {
            //     return 'table-danger';
            // } else if (rowIndex === 6) {
            //     return 'table-warning';
            // }
            return 'table-success';
        }
    }
}
</script>
